import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a09c8612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Material" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "total" }
const _hoisted_5 = { class: "inner_number" }
const _hoisted_6 = { class: "total" }
const _hoisted_7 = { class: "inner_number" }
const _hoisted_8 = {
  "data-v-234cf3ea": "",
  class: "handle-btns"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalTableConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { reactive, ref } from 'vue'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
import { useStore } from '@/store'
import { usePermission } from '@/hooks/usePermission'
import { usePageModalTable } from '@/hooks/usePageModalTable'
import { queryStatistics } from '@/service/main/material/statistics'
import PageContent from '@/components/PageContent.vue'
import { Excel } from '@/utils/ExcelJs'
import { getListData } from '@/service/main/system'


export default /*#__PURE__*/_defineComponent({
  __name: 'Statistics',
  setup(__props) {

const isView = usePermission('materialStatistics', 'view')

initEmptyParam()

var queryParam = {
  type: 0,
  longterm: 0,
  date: [getBeforeDate('', 1), getBeforeDate('', 1)]
}
const store = useStore()
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}

const modalTitle = ref('新增')

const statitiscal = ref({ totalSend: 0, totalReceive: 0 })

const initStatic = async () => {
  let queryInfo = store.state.system.queryInfo
  statitiscal.value = await queryStatistics({
    ...queryInfo,
    pageNo: 1,
    pageSize: 10
  })
}

initStatic()

const searchCb = async (item: any) => {
  statitiscal.value = await queryStatistics(item)
}

const previewImgUrl = ref(window.location.origin + '/previewImg.html?url=')

const showTooltip = ref(false)
const tooltipLeft = ref(0)
const currentImageUrl = ref('')
const tooltipTop = ref(0)

const tooltipRef = ref<null | HTMLElement>(null)
let tooltipWidth = tooltipRef.value?.offsetWidth || 0
let tooltipHeight = tooltipRef.value?.offsetHeight || 0
let targetElement: HTMLElement

const getCellColor = (type: number) => {
  if (type == 2) {
    return 'dodgerblue'
  } else if (type == 5) {
    return 'darkorange'
  }
}

const imageLoaded = () => {
  tooltipWidth = tooltipRef.value?.offsetWidth || 0
  tooltipHeight = tooltipRef.value?.offsetHeight || 0

  const rect = targetElement.getBoundingClientRect()

  let rightTopX = rect.right
  let rightTopY = rect.top

  // 防止溢出右侧
  if (rightTopX + tooltipWidth > window.innerWidth) {
    rightTopX = window.innerWidth - tooltipWidth - 10
  }

  // 防止溢出底部
  if (rightTopY - tooltipHeight < 0) {
    rightTopY = tooltipHeight - store.state.system.scrollPosition + 10
  }

  // 防止溢出顶部（尽管根据你的逻辑这不太可能发生，但为了完整性还是包含）
  if (rightTopY + tooltipHeight > window.innerHeight) {
    rightTopY = window.innerHeight - tooltipHeight - 10
  }

  tooltipLeft.value = rightTopX + 10
  tooltipTop.value = rightTopY - 10
}

const handleMouseEnter = (
  row: any,
  column: any,
  cell: HTMLElement,
  event: MouseEvent
) => {
  if (
    column.property === 'materialTypeName' &&
    (row.materialType == 2 || row.materialType == 5)
  ) {
    showTooltip.value = true
    currentImageUrl.value = row.url2 ? row.url2 : row.url

    targetElement = event.target as HTMLElement

    // 计算右上角坐标
    const rect = targetElement.getBoundingClientRect()

    const rightTopX = rect.right
    const rightTopY = rect.top

    tooltipLeft.value = rightTopX + 10
    tooltipTop.value = rightTopY - 10
  }
}

const handleMouseLeave = () => {
  showTooltip.value = false
  currentImageUrl.value = ''
}

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  if (selectRows.value.length > 0) {
    queryInfo.mids = selectRows.value
  }
  return await getListData(
    '/main/materialStatistics/queryExportData',
    queryInfo
  )
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

let selectRows = ref([])

const handleSelectionChange = (selection: any) => {
  if (selection.length > 0) {
    selectRows.value = selection.map((item: any) => item.materialId)
  } else {
    selectRows.value = []
  }
}

const handleMaterialSum = (item: any) => {
  getExportData().then((res) => {
    // 素材ID	素材类型	素材标题/发送关键词	发送数	回复数	回复率
    let customHeader = [
      '素材ID',
      '素材类型',
      '素材标题/发送关键词',
      '发送数',
      '回复数',
      '回复率'
    ]
    let header = [
      'materialId',
      'materialTypeName',
      'materialTitle',
      'send',
      'reply',
      'replyPercent'
    ]
    // 企业主体	账户ID	名称	发送时间	客户名称	回复时间	回复内容
    let subCustomHeader = [
      '企业主体',
      '账户ID',
      '名称',
      '发送时间',
      '客户名称',
      '回复时间',
      '回复内容'
    ]
    let subHeader = [
      'corpName',
      'sid',
      'sname',
      'sendTime',
      'uname',
      'replyTime',
      'content'
    ]

    let queryInfo = store.state.system.queryInfo
    // 根据日期范围，把每天日期字符串放进数组，后期根据这个日期范围，顺序地显示在表格里
    let startDate = queryInfo.date[0]
    let endDate = queryInfo.date[1]

    // 文件名
    let filename =
      startDate +
      '-' +
      endDate +
      '~' +
      ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')

    let firstPage = res

    let options = []
    options.push({
      name: '素材统计' + filename,
      title: '素材统计-' + filename,
      data: reactive(firstPage),
      header,
      customHeader,
      sheetName: '素材统计汇总'
    })
    const MaxLength = 30
    res.forEach((item: any) => {
      let prefix =
        item.materialId +
        '-' +
        item.materialTitle.replaceAll(/[\\/*?\[\]]/g, '-')
      let dots = ''
      let suffix = '(' + item.materialTypeName + ')'
      let sheetName = prefix + dots + suffix
      if (sheetName.length > MaxLength) {
        dots = '...'
        sheetName =
          prefix.substring(0, MaxLength - dots.length - suffix.length) +
          dots +
          suffix
      }
      options.push({
        data: reactive(item.dataList),
        header: subHeader,
        customHeader: subCustomHeader,
        sheetName: sheetName
      })
    })

    const excel = new Excel()
    excel.exportExcelMulti(options)
  })
}

const handleSortDataChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [
  pageModalTableRef,
  defaultTableInfo,
  dataList,
  handleViewClick,
  dataCount,
  handleSortChange
] = usePageModalTable()
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(
  resetCb,
  searchCb
)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageModalTable = _resolveComponent("PageModalTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode("总发送数: "),
          _createElementVNode("em", _hoisted_5, _toDisplayString(statitiscal.value && statitiscal.value.totalSend ? statitiscal.value.totalSend : 0), 1)
        ]),
        _createElementVNode("span", _hoisted_6, [
          _createTextVNode("总回复数: "),
          _createElementVNode("em", _hoisted_7, _toDisplayString(statitiscal.value && statitiscal.value.totalReceive
              ? statitiscal.value.totalReceive
              : 0), 1)
        ])
      ])
    ]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "materialStatistics",
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onMaterialSum: handleMaterialSum,
      onSelectionChange: handleSelectionChange,
      onSortChange: handleSortDataChange
    }, {
      type: _withCtx((scope) => [
        (scope.row.materialType == 2 || scope.row.materialType == 5)
          ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              href: 
            previewImgUrl.value + (scope.row.url2 ? scope.row.url2 : scope.row.url)
          ,
              referrerpolicy: 'no-referrer',
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle({
              color: getCellColor(scope.row.materialType),
              cursor: 'pointer'
            })
                }, _toDisplayString(scope.row.materialTypeName), 5)
              ]),
              _: 2
            }, 1032, ["href"]))
          : _createCommentVNode("", true)
      ]),
      longterm: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(scope.row.longterm == 0 ? '' : '是'), 1)
      ]),
      special: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_8, [
          (_unref(isView) && scope.row.reply > 0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                icon: "el-icon-view",
                onClick: ($event: any) => (_unref(handleViewClick)(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isView) && scope.row.reply == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "无数据"))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createVNode(_Transition, { name: "el-zoom-in-center" }, {
      default: _withCtx(() => [
        (showTooltip.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: tooltipRef,
              style: _normalizeStyle({ left: tooltipLeft.value + 'px', top: tooltipTop.value + 'px' }),
              class: "tooltip"
            }, [
              _createElementVNode("img", {
                src: currentImageUrl.value,
                alt: "",
                referrerpolicy: "no-referrer",
                onLoad: _cache[0] || (_cache[0] = ($event: any) => (imageLoaded()))
              }, null, 40, _hoisted_10)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_PageModalTable, {
      title: "",
      ref_key: "pageModalTableRef",
      ref: pageModalTableRef,
      defaultInfo: _unref(defaultTableInfo),
      contentTableConfig: _unref(modalTableConfig),
      dataList: _unref(dataList),
      dataCount: _unref(dataCount),
      onSortChange: _unref(handleSortChange)
    }, null, 8, ["defaultInfo", "contentTableConfig", "dataList", "dataCount", "onSortChange"])
  ]))
}
}

})